// Copyright 2025. WebPros International GmbH. All rights reserved.

export const ELEMENTS = {
    STATUS: 'status',
    COMPUTE_RESOURCE: 'link-to-compute-resource',
    COMPUTE_RESOURCE_VM: 'link-to-compute-resource-vm',
};

export const ACTIONS = {
    RESTORE: 'restore',
    DELETE: 'delete',
    FILTERS: 'filters',
    NEXT_BACKUP_AT: 'next-backup-at',
    CREATE_BUTTON: 'backup-create-button',
    ENABLE_SWITCH: 'backup-enable-switch',
    DISASTER_RECOVERY_ENABLE_SWITCH: 'disaster-recovery-enable-switch',
};

export const BACKUPS = {
    TABLE: 'backups-table',
};
